import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import GodsView from './pages/godsView';
import RoutesView from './pages/routesView';
import enMessages from './locales/en';
import esMessages from './locales/es';
import UpdatePrompt from './UpdatePrompt';

const messages = {
  en: enMessages,
  es: esMessages,
};
if (process.env.NODE_ENV !== "development") {
  console.log = function () { };
}

function App() {
  const locale = 'es';

  return (
    <IntlProvider locale={locale} messages={messages[locale]}>
      <Router>
        <UpdatePrompt />
        <Routes>
          <Route path="/" element={<GodsView />} />
          <Route path="/routes" element={<RoutesView />} />
        </Routes>
      </Router>
    </IntlProvider>
  );
}

export default App;
